import { render, staticRenderFns } from "./find-dialog.vue?vue&type=template&id=08b04d8c&"
import script from "./find-dialog.vue?vue&type=script&lang=js&"
export * from "./find-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports